import apiAuthClient from '@/services/apiAuthClient';

import errorHandler from '@/utilities/serverErrorHandler';

export const actions = {

  updateClaim ({ commit, getters, dispatch, rootGetters }, payload) {
    commit('UPDATE_CLAIM', payload);

    const claim = getters.getCurrentClaim;

    dispatch('ui/updateInterstitial', { isLoading: true, message: 'Updating your claim...' }, { root: true });
    return apiAuthClient.put('icclaims', claim, rootGetters['auth/getAccessToken']).then((res) => {
      if (res.status === 200) {
        return true;
      }
    }).catch((err) => {
      return errorHandler('claimErrors', err, 'put');
    }).finally(() => {
      dispatch('ui/updateInterstitial', { isLoading: false, message: '' }, { root: true });
    });
  },
  fetchClaims ({ commit, dispatch, rootGetters }) {
    dispatch('ui/updateInterstitial', { isLoading: true, message: 'Finding your claim...' }, { root: true });

    return apiAuthClient.get(`icclaims/${process.env.VUE_APP_CONTRACT_ID}`, rootGetters['auth/getAccessToken']).then((res) => {
      if (res.status === 200) {
        commit('UPDATE_CLAIMS', res.data);
        dispatch('settings/updateDownloadedFlag', { flagName: 'claimsDownloaded', flagStatus: true }, { root: true });
        return true;
      }
    }).catch((err) => {
      return errorHandler('claimErrors', err);
    }).finally(() => {
      dispatch('ui/updateInterstitial', { isLoading: false, message: '' }, { root: true });
    });
  },
  fetchCurrentClaim ({ commit, getters }, payload) {
    const claims = getters.getClaims;

    const result = claims.find(obj => {
      return obj.ua_icclaimid === payload;
    });
    commit('UPDATE_CLAIM', result);
  },
  resetClaim ({ commit, dispatch }) {
    commit('RESET_CLAIMS');
    dispatch('settings/updateDownloadedFlag', { flagName: 'claimsDownloaded', flagStatus: false }, { root: true });
  },
  prefillClaim ({ commit, dispatch, rootGetters, getters }) {
    const payload = rootGetters['eoi/getEOI'];
    commit('PREFILL_CLAIM', payload);

    const claim = getters.getClaim;

    dispatch('updateClaim', claim);
  }

};
